var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1002 12.1004C28.1382 12.8395 28.0709 13.5803 27.9002 14.3004C27.5918 16.0023 26.9099 17.6146 25.9037 19.0214C24.8974 20.4281 23.5917 21.5942 22.0807 22.4358C20.5697 23.2774 18.8908 23.7735 17.165 23.8884C15.4393 24.0034 13.7095 23.7342 12.1002 23.1004C11.6054 22.9282 11.1349 22.6929 10.7002 22.4004L10.0002 22.0004C10.0002 21.9004 9.90019 21.8004 9.90019 21.7004C9.49848 20.6121 9.29527 19.4605 9.3002 18.3004V17.7004C9.21826 17.4078 9.18448 17.1038 9.2002 16.8004C9.19214 14.3266 9.96173 11.9129 11.4002 9.9004C10.1649 9.255 8.7939 8.91226 7.40019 8.9004H6.7002C7.4467 8.11189 8.34591 7.48361 9.34305 7.05381C10.3402 6.62401 11.4144 6.40169 12.5002 6.4004C13.277 6.39483 14.0508 6.49576 14.8002 6.70039C16.6697 5.57081 18.816 4.98232 21.0002 5.0004C22.9868 4.98805 24.9454 5.4691 26.7002 6.4004C27.62 8.15958 28.1003 10.1153 28.1002 12.1004Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 22.0005L9.5 24.9005L9.2 27.9005L6.60001 25.3005L4 22.7005L7 22.4005L9.89999 22.0005Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1999 18.0006C23.3264 17.9742 20.5796 16.8142 18.557 14.7729C16.5344 12.7316 15.3998 9.9742 15.3999 7.10059",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.4002C22.2075 10.4002 22.7 9.90771 22.7 9.3002C22.7 8.69269 22.2075 8.2002 21.6 8.2002C20.9925 8.2002 20.5 8.69269 20.5 9.3002C20.5 9.90771 20.9925 10.4002 21.6 10.4002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.f6c04c6c0aa4ada08a3d5f246d312611.svg";
export { ForwardRef as ReactComponent };